import React from "react";
import "./Home.css";

export default function Home() {
  const posterSrc = `${process.env.PUBLIC_URL}/Images/main.jpg`;
  return (
    <main className="home">
      <div className="bg-gradient"></div>

      <div className="bokeh">
        {Array.from({ length: 12 }).map((_, i) => (
          <span key={i} style={{ "--i": i }}></span>
        ))}
      </div>

      <div className="string-lights">
        {Array.from({ length: 18 }).map((_, i) => (
          <span key={i} style={{ "--h": i * 20 }}></span>
        ))}
      </div>

      <section className="hero">
        <div className="hero-text">
          <div className="badge">Meat Farm</div>
          <h1 className="title"><span>Coming Soon</span></h1>
          <p className="subtitle">Fresh mutton, chicken, and farm eggs</p>
          <p className="subtitle">Email : goat.ind.in@gmail.com</p>
          <p className="subtitle">Mobile Number : 95 123 123 39</p>
          <div className="celebrations">
            <div className="emoji">🐐</div>
            <div className="emoji">🐓</div>
            <div className="emoji">🥚</div>
            <div className="emoji">🎉</div>
          </div>
        </div>

        <div className="hero-media">
          <div className="media-wrap">
            <img src={posterSrc} alt="Coming soon poster" loading="eager" />
            <div className="shine"></div>
          </div>
        </div>
      </section>

      <section className="cards">
        <div className="card">
          <div className="card-icon">🌿</div>
          <h3>Farm Fresh</h3>
          <p>Mutton, chicken, and eggs from trusted local farms.</p>
        </div>
        <div className="card">
          <div className="card-icon">🧊</div>
          <h3>Handled Right</h3>
          <p>Chilled chain and hygiene at every step.</p>
        </div>
        <div className="card">
          <div className="card-icon">🚚</div>
          <h3>Doorstep Joy</h3>
          <p>Fast delivery in your area once we launch.</p>
        </div>
      </section>

      <div className="fireworks">
        <div className="firework f1"></div>
        <div className="firework f2"></div>
        <div className="firework f3"></div>
      </div>

      <div className="balloons">
        {Array.from({ length: 7 }).map((_, i) => (
          <span key={i} style={{ "--x": `${10 + i * 12}%`, "--d": 4 + i * 0.3 }}></span>
        ))}
      </div>

      <footer className="footer">
        <div className="ticker">
          <div className="marquee">
            We are opening soon • Fresh Meat • Farm Eggs • Quality You Can Trust • See You Soon •
          </div>
        </div>
        <div className="contact">
          <span>Questions? </span>
          <a href="mailto:goat.ind.in@gmail.com">goat.ind.in@gmail.com</a><br />
          <a href="tel:+919512312339">95 123 123 39</a>
        </div>
      </footer>
    </main>
  );
}
